import { useViewCoinvestTeaserDocument } from "@vega-api/generated/coinvest-deal-teaser-docs/coinvest-deal-teaser-docs";
import { useViewCoinvestNdaDocument } from "@vega-api/generated/coinvest-ndas-upload/coinvest-ndas-upload";

export const useCoInvestDocument = (
  documentId: string | null,
  isTeaser: boolean,
  enabled = true,
) => {
  const {
    data: teaserResponse,
    isLoading: isTeaserLoading,
    error: teaserError,
  } = useViewCoinvestTeaserDocument(documentId!, {
    query: {
      enabled: enabled && !!documentId && isTeaser,
      select: (data) => data.data?.presignedUrl?.url,
    },
  });

  const {
    data: ndaResponse,
    isLoading: isNdaLoading,
    error: ndaError,
  } = useViewCoinvestNdaDocument(documentId!, {
    query: {
      enabled: enabled && !!documentId && !isTeaser,
      select: (data) => data.data?.presignedUrl?.url,
    },
  });

  const presignedUrl = isTeaser ? teaserResponse : ndaResponse;
  const isLoading = isTeaser ? isTeaserLoading : isNdaLoading;
  const error = isTeaser ? teaserError : ndaError;

  return {
    presignedUrl,
    isLoading,
    error,
  };
};
